import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const parseProductIntelligence = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const intro = [];
  const urlSummaryLines = [];
  const actions = [];
  let phase = "intro";

  lines.forEach((line) => {
    if (/^we will execute:\s*/i.test(line)) {
      phase = "actions";
      actions.push(line);
      return;
    }

    if (/^\d+\s+product urls?\s+flagged/i.test(line)) {
      phase = "summary";
      urlSummaryLines.push(line);
      return;
    }

    if (/^https?:\/\//.test(line) || /^[•\-*]\s*https?:\/\//.test(line)) {
      phase = "summary";
      urlSummaryLines.push(line.replace(/^[•\-*]\s*/, ""));
    } else if (phase === "summary" && /^[•\-*]\s/.test(line)) {
      urlSummaryLines.push(line.replace(/^[•\-*]\s*/, ""));
    } else if (phase === "actions") {
      phase = "actions";
      actions.push(line);
    } else {
      intro.push(line);
    }
  });

  const actionText = actions.join(" ").trim();

  const urlSummaryText = urlSummaryLines.join(" ").trim();
  const countMatch = urlSummaryText.match(/^(\d+)\s+product urls?\s+flagged/i);

  return {
    intro: intro.join(" ").trim(),
    flaggedCount: countMatch ? countMatch[1] : "",
    urlSummaryText,
    actionText,
  };
};

const ProductIntelligenceDeepClean = ({ markdown = "" }) => {
  const { intro, flaggedCount, urlSummaryText, actionText } =
    parseProductIntelligence(markdown);
  if (!intro && !urlSummaryText && !actionText) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Product Intelligence Deep Clean</h3>
      {intro ? (
        <div className={styles.card}>
          <p className={styles.paragraph}>{intro}</p>
        </div>
      ) : null}
      {urlSummaryText ? (
        <div className={styles.summaryCard}>
          {/* <h4 className={styles.summaryTitle}>Product URL Status</h4> */}
          <div className={styles.issueItem}>
            <div className={styles.issueHead}>
              {/* <p className={styles.issueLabel}>
                Product URLs flagged as not indexed
              </p> */}
              {/* {flaggedCount ? (
                <span className={styles.issueCount}>{flaggedCount} URLs</span>
              ) : null} */}
            </div>
            <p className={styles.paragraph} style={{ marginBottom: 0 }}>
              {urlSummaryText}
            </p>
          </div>
        </div>
      ) : null}
      {actionText ? (
        <div className={styles.actionCard}>
          <p className={styles.actionTitle}>Execution Plan</p>
          <p className={styles.actionText}>{actionText}</p>
        </div>
      ) : null}
    </div>
  );
};

export default ProductIntelligenceDeepClean;
